import AsyncStorage from '@react-native-async-storage/async-storage';
import { fromPromise } from 'xstate';

import { getDecrementedCounterValue, getIncrementedCounterValue } from './counter-machine.utils';

import type { CounterMachineContext } from './counter-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createGetCounterValueActor(asyncStorageKey: string) {
  return fromPromise<string | null>(async () => AsyncStorage.getItem(asyncStorageKey));
}

export function createIncrementCounterActor(asyncStorageKey: string) {
  return fromPromise<number, CounterMachineContext>(async ({ input }) => {
    const { value, valueAsString } = getIncrementedCounterValue(input.value);

    await AsyncStorage.setItem(asyncStorageKey, valueAsString);

    return value;
  });
}

export function createDecrementCounterActor(asyncStorageKey: string) {
  return fromPromise<number, CounterMachineContext>(async ({ input }) => {
    const { value, valueAsString } = getDecrementedCounterValue(input.value);

    await AsyncStorage.setItem(asyncStorageKey, valueAsString);

    return value;
  });
}

export function createResetCounterActor(asyncStorageKey: string) {
  return fromPromise<number>(async () => {
    await AsyncStorage.setItem(asyncStorageKey, '0');

    return 0;
  });
}
